export default {
    setupDate: {id: 'apply'},
    day_1: {id: 'label_day_1'},
    days_7: {id: 'label_days_7'},
    month_1: {id: 'label_month_1'},
    months_3: {id: 'label_months_3'},
    months_6: {id: 'label_months_6'},
    customDate: {id: 'label_custom'}
}